module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/ACCOUNTING-FINANCE-aa1de6e0f746313103bc3ec5032ebe7e.png";